import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Toast, ToastService } from '../../services/toast.service';

/**
 * Wyświetla komunikat wystawiony przez ToastService. Jedna instancja na aplikację —
 * siedzi w app.component.html obok pozostałych globalnych doków.
 *
 * Import wprost z pliku, nie z barrela `../../services`: ModalService (który ten barrel
 * eksportuje) importuje komponenty pop-upów, więc przez barrel łatwo o cykl zależności.
 */
@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {

  readonly toast$: Observable<Toast> = this.toast.current;

  constructor(private toast: ToastService) { }
}
